import type { TenantInheritanceFieldConfig } from "@/v2/framework/dialog/types";

import type { InheritanceFieldDescriptor } from "../types";

export function resolveEntityPath(
  path: string,
  config: TenantInheritanceFieldConfig,
): string | undefined {
  if (config.entityPath) {
    return config.entityPath;
  }

  return path.includes(".") ? path.slice(0, path.lastIndexOf(".")) : undefined;
}

export function resolveInheritanceDescriptor(
  path: string,
  fieldName: string,
  config: TenantInheritanceFieldConfig,
): InheritanceFieldDescriptor {
  const entityPath = resolveEntityPath(path, config);

  return {
    path,
    field: fieldName,
    entityPath,
    sourcePolicyScope: entityPath,
    computedKey: config.computedKey,
    parentKey: config.parentKey,
    patchKey: config.patchKey ?? fieldName,
  };
}
